import React, { Component } from 'react'
import { MyStore } from '../../../services/Store'
import axios from '../../../services/AxiosOrders'
import { Table, Header, Image } from 'semantic-ui-react'
// import { Consumer, MyContext, Provider } from '../../../context/Context'

// import firebase from 'firebase/app';

// import { authState } from 'rxfire/auth';
// import { getDownloadURL } from 'rxfire/storage';
// import { switchMap, filter } from 'rxjs/operators';

import 'firebase/firestore';
// import { collectionData } from 'rxfire/firestore';
import moment from 'moment'
const uuid = require('uuid/v4');




// const  config = {
//     apiKey: "AIzaSyByPyCA_FQBPRd27kOB9rBnfbQMTP0_U3o",
//     authDomain: "fir-mlstiudio-91.firebaseapp.com",
//     databaseURL: "https://fir-mlstiudio-91.firebaseio.com",
//     projectId: "fir-mlstiudio-91",
//     storageBucket: "fir-mlstiudio-91.appspot.com",
//     messagingSenderId: "518571447957",
//     appId: "1:518571447957:web:34ea17728d777306dfad9c",
//     measurementId: "G-Y939XZGEKF"
// }


export class FileLogTable extends Component {
  constructor(props) {
    super(props)
    this.db = MyStore.firestore();
    this.storageRef = MyStore.storage().ref();
    this.databaseRef = MyStore.database().ref();
    this.userID = ''
    // this.app = undefined;

  }
  state = {
    files: [],
    logs: []

  }

  

  // /M1afHNBOBJWe7EUZN3kRKwVg1po1/02c2d596-8be7-4012-8901-a618f9efa22c

//userid/cards/:id
// userid/:filegroupid/ * storage
// this.storageRef.child(this.userID).child(this.props.filesGroupId).child(name).delete().then(()=>{
//userid/files/:id
// this.databaseRef.child(user.uid).child('files').child(this.props.filesGroupId).on('value', snap => {
//userid/logs/:id
//  this.databaseRef.child(user.uid).child('logs').child(this.props.filesGroupId).on('value', snap => {

//groups/oid/cards
//:groupId/:filegroupid/    * storage
// this.storageRef.child('groups').child(this.props.oid).child(this.props.filesGroupId).child(name).delete().then(()=>{

//groups/:oid/files
// a = databaseRef.child(groups).child(this.props.oid).child('files').child(this.props.filesGroupId).on('value', snap => {})

//groups/:oid/logs
// a = databaseRef.child(groups).child(this.props.oid).child('logs').child(this.props.filesGroupId).on('value', snap => {})






  authStateListner = () => {
    // console.log('--------------authstatelistener----------  context.js line 46')
    // console.log(this.props)

    MyStore.auth().onAuthStateChanged((user) => {
      // if (!this.props.filesGroupId){
      //   return
      // }
      // console.log('----------- user ------------ ')
      // console.log(user.uid)
      if (user) {
        this.databaseRef.child('groups').child(this.props.oid).child('files').child(this.props.filesGroupId).on('value', snap => {
          // console.log(snap.val())
          let myArr = []
          // console.log('----------- function 01 -------------')
          for (const key in snap.val()) {
            myArr.push(Object.assign({}, snap.val()[key]));
            // console.log(snap.val()[key]);
          }
          if (snap.val() != null) {
            this.setState({
              files: myArr
            })
          }
          else {
            this.setState({
              files: []
            })
          }
        });




        this.databaseRef.child('groups').child(this.props.oid).child('logs').child(this.props.filesGroupId).on('value', snap => {
          // console.log(snap.val())
          let myArr = []
          // console.log('----------- function 02 -------------')
          for (const key in snap.val()) {
            myArr.push(Object.assign({}, snap.val()[key]));
          }
          if (snap.val() != null) {
            this.setState({
              logs: myArr
            })
          }
          else {
            this.setState({
              logs: []
            })
          }

        });
      }
      else {
        this.setState({ user: null, todos: [] })
        this.userID = null
      }
      if (user !== null){
        this.userID = user.uid
      }
  
    })
  }

  // this.storageRef.child(name).delete().then(() => {

  
  deleteFile = (name, key) => {
    // console.log('----------------name key ----------------')
    // console.log(name, key)

    // this.storageRef.child(this.props.auth.localId).child(this.props.filesGroupId).child(name).delete().then(()=>{

    //   this.databaseRef.child(this.props.auth.localId + '/files/' + this.props.filesGroupId).child(key).remove().then(()=>{

        this.storageRef.child('groups').child(this.props.oid).child(this.props.filesGroupId).child(name).delete().then(()=>{
    // this.storageRef.child(this.userID).child(this.props.filesGroupId).child(name).delete().then(()=>{

    //   this.databaseRef.child(this.userID + '/files/' + this.props.filesGroupId).child(key).remove().then(()=>{

        this.databaseRef.child('groups').child(this.props.oid).child('files').child(this.props.filesGroupId).child(key).remove().then(()=>{
      // })
      // this.databaseRef.child(this.props.uid).child("files").child(key).remove().then(() => {
        // console.log("deleted")
        // this.databaseRef.on('value', snap => {

        //   let myArr = []

          // console.log(snap.val())
          // for (const key in snap.val()) {
          //   myArr.push(Object.assign({}, snap.val()[key].metadataFile, { key: key }));
          //   console.log(snap.val()[key].metadataFile);
          // }

          // if (snap.val() != null) {
          //   this.setState({
          //     myFiles: myArr
          //   })
          // }
          // else {
          //   this.setState({
          //     myFiles: []
          //   })
          // }
        // })
      })

      const logsRef = this.databaseRef.child(this.userID + '/logs/' + this.props.filesGroupId)
      logsRef.push().set({
        id: uuid(),
        action: `${name} deleted`,
        // timestamp: Date.now().toString()
        // timestamp: Date(Date.now()).toString()
        timestamp: Date.now(),
        momentTimestamp: moment().format('LLL')
      });


      // this.databaseRef.child(this.localId + '/logs/' + this.props.filesGroupId).push().set({
      //   id: uuid(),
      //   action: `${name} deleted`,
      //   // timestamp: Date.now().toString()
      //   // timestamp: Date(Date.now()).toString()
      //   timestamp: Date.now(),
      //   momentTimestamp: moment().format('LLL')
      // });

      // this.databaseRef.child(this.props.uid).child("log").push().set({
      //   action: `${name} deleted`,
      //   timestamp: new Date()
      // });
    })
  }

  componentDidMount(){
    // const body = document.getElementsByTagName('body')[0];
    // body.style.cssText = 'transition: background .5s ease';


    // console.log(this.props)
    // console.log(this.props.oid)
  }

  componentWillMount() {
  
    // this.authStateListner()
    // if (!this.props.filesGroupId){
    //   this.props.filesGroupId = 0
    // }
    // console.log('----------- tester comp will mount -----------')
    // console.log(this.props.filesGroupId )
    // console.log(this.props.auth )
    // console.log(this.context.auth.localId)
    this.authStateListner()
  }



  formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }




  render() {
    const files = this.state.files.map(myfile => (

      <Table.Row key={myfile.metadataFile.key}   >
        {/* <div>{setIcon(myfile.contentType)}</div> */}
        <Table.Cell >
          <Header as='h1' image>
            <Image src={myfile.metadataFile.downloadURL} width="128" height="128"  ></Image>
            <Header.Content>
              {/* <h4>Delete</h4> */}
              <Header.Subheader>
              <a className="text_blue download" href={myfile.metadataFile.downloadURL} target="_blank"><i className="fa fa-download" aria-hidden="true"></i></a> 
                  {/* <i className="fa fa-trash" aria-hidden="true"    style={{cursor:'pointer'}} onClick={this.deleteFile.bind(this, myfile.metadataFile.name, myfile.metadataFile.key)} ></i> */}
              </Header.Subheader>
        {/* <a class="btn_delete delete" ><i class="fa fa-trash" aria-hidden="true"></i></a> */}
                 
                 
            </Header.Content>
          </Header>
        </Table.Cell>
        <Table.Cell   >{myfile.metadataFile.name}</Table.Cell>
        <Table.Cell   >{myfile.metadataFile.contentType}</Table.Cell>
        <Table.Cell   >{this.formatBytes(myfile.metadataFile.size)}</Table.Cell>
        <Table.Cell  > 
            {/* <a className="text_blue download" href={myfile.metadataFile.downloadURL} target="_blank"><i className="fa fa-download" aria-hidden="true"></i></a> */}

       <a>  <i className="fa fa-trash" aria-hidden="true"    style={{cursor:'pointer'}} onClick={this.deleteFile.bind(this, myfile.metadataFile.name, myfile.metadataFile.key)} ></i> </a>
        
        </Table.Cell>

      </Table.Row>
    )
    )

 
    const logs = this.state.logs.map(myfile => (
      <Table.Row key={myfile.id} >
        <Table.Cell>{myfile.displayName}</Table.Cell>
        <Table.Cell>{myfile.action} </Table.Cell>
        <Table.Cell>{myfile.momentTimestamp}</Table.Cell>
      </Table.Row>
    )
    )

    return (
      <div >
        <h2>Image Files</h2>
        <Table singleLine striped color='teal'   >
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell></Table.HeaderCell>
              <Table.HeaderCell>File Name</Table.HeaderCell>
              <Table.HeaderCell>Type</Table.HeaderCell>
              <Table.HeaderCell>Size</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {files}
          </Table.Body>

          <Table.Footer>
            <Table.Row>
              <Table.HeaderCell>{Object.keys(this.state.files).length} Files</Table.HeaderCell>
              {/* <Table.HeaderCell>2 Approved</Table.HeaderCell> */}
              <Table.HeaderCell />
            </Table.Row>
          </Table.Footer>
        </Table>

        {/* <hr></hr> */}
        <h2>File Log</h2>
        <Table singleLine striped color='teal'    >
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>User</Table.HeaderCell>
              <Table.HeaderCell>Action</Table.HeaderCell>
              <Table.HeaderCell>Time</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {logs}
          </Table.Body>
        </Table>
        <br></br><br></br>
      </div>
    );
  }
}




const colors = [
  'red',
  'orange',
  'yellow',
  'olive',
  'green',
  'teal',
  'blue',
  'violet',
  'purple',
  'pink',
  'brown',
  'grey',
  'black',
]


// FileLogTable.contextType = MyContext;
export default FileLogTable